import { IContent } from "@kunduz/data-access-cms-api";
import React, { ReactElement } from "react";
import { useAppContext } from "@kunduz/feature-website-context";
import { blue, green } from "@kunduz/ui-components";
import { CmsMobileNavItems } from "./cmsMobileNavItems";
import { Avatar } from "@kunduz/ui-atoms";
import { User01 } from "@untitled-ui/icons-react";
import { formatPhoneNumberForDisplay } from "@kunduz/utility-common";
import styles from "./mobileBottom.module.scss";

export const MobileBottom = (props: {
  headerType: "student" | "teacher" | "school";
  mobileBottomCmsData?: IContent.HeaderItemsResponse["components"];
  lang: "tr" | "en";
}): ReactElement => {
  const { kunduzApiToken, student, profiles } = useAppContext();

  const iconColors = {
    student: blue[600],
    teacher: green[600],
    school: blue[600],
  };

  const filteredMobileCtaItems = props.mobileBottomCmsData?.filter((x) => {
    if (kunduzApiToken) return !x.data.hide_for_authenticated_user;
    else return !x.data.hide_for_unauthenticated_user;
  });

  const name = profiles
    ? `${profiles.first_name} ${profiles.last_name}`
    : undefined;
  const phoneOrEmail = student.data?.phone_number
    ? `+${student.data.phone_number
        ?.country_code} ${formatPhoneNumberForDisplay(
        student.data.phone_number.number,
      )}`
    : student.data?.email
      ? student.data.email
      : profiles
        ? `${profiles.email || profiles.phone_number}`
        : undefined;

  return (
    <div className={styles["wrapper"]}>
      {profiles ? (
        <div className={styles.userBox}>
          <Avatar placeholderIcon={User01} />
          <div className={styles.nameBox}>
            <p className={styles.name}>{name}</p>
            <p className={styles.phone}>{phoneOrEmail}</p>
          </div>
        </div>
      ) : (
        <CmsMobileNavItems
          cmsData={filteredMobileCtaItems}
          iconColor={iconColors[props.headerType]}
          lang={props.lang}
        />
      )}
    </div>
  );
};
